// src/utils/tokenStorage.js
const STORAGE_KEY = "imported_tokens";

export function loadTokens() {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : {};
}

export function saveToken(chain, token) {
  const all = loadTokens();
  if (!all[chain]) all[chain] = [];

  // Convert any BigInt in token to string to prevent JSON errors
  const safeToken = JSON.parse(
    JSON.stringify(token, (key, value) =>
      typeof value === "bigint" ? value.toString() : value
    )
  );

  // prevent duplicates by address
  if (!all[chain].find(t => t.address === safeToken.address)) {
    all[chain].push(safeToken);
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function getTokensByChain(chain) {
  const all = loadTokens();
  return all[chain] || [];
}